<div class="form-group">
    <label class="button-group-heading">{{ heading }}</label>
    <mat-radio-group class="radio-button-group" [(ngModel)]="selectedOption" (change)="selectOption()">
        <mat-radio-button default [value]="null" color="primary">None</mat-radio-button>
        <mat-radio-button *ngFor="let option of options" [value]="option.value" color="primary">{{option.name}}</mat-radio-button>
    </mat-radio-group>
</div>